import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { Send as SendIcon } from "@material-ui/icons";
import { useTriggerPublishWaterLevels } from "./useTriggerPublishWaterLevels";

export const PublishWaterLevelsButton = ({
  fullWidth = false,
  variant = "contained",
  size = "large",
}) => {
  const { triggerPublish, isLoading } = useTriggerPublishWaterLevels();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleOpenConfirm = () => setConfirmOpen(true);
  const handleCloseConfirm = () => setConfirmOpen(false);
  const handleConfirm = () => {
    triggerPublish(undefined);
    handleCloseConfirm();
  };

  return (
    <>
      <Button
        fullWidth={fullWidth}
        style={{ minWidth: "200px" }}
        variant={variant}
        size={size}
        color="primary"
        onClick={handleOpenConfirm}
        startIcon={<SendIcon />}
      >
        Publish Water Levels to Graphs
      </Button>

      {/* Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
        <DialogTitle>Confirm Publish</DialogTitle>
        <DialogContent>
          <Typography>
            This will force new water level records to publish immediately.
          </Typography>
          <Typography>
            The process may take approximately <strong>30 seconds</strong> to
            complete, and updates should be live in{" "}
            <strong>no more than 1 minute</strong>.
          </Typography>
          <Typography>
            If you do not see the changes within one minute, please refresh the
            appropriate page. If after refreshing the updates still do not
            appear, please contact LRE Water.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseConfirm}
            color="primary"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            style={{ width: "100px" }}
            onClick={handleConfirm}
            color="secondary"
            variant="contained"
            autoFocus
            disabled={isLoading}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
